import React from "react";
import {Button, CircularProgress} from "@mui/material";

const LoadingButton = (props) => {
    const {size, color, round, className} = props;
    return (
        <Button className={className} round={round} size={size} color={color}>
            <CircularProgress color="gray" size={18} />
        </Button>
    )
}
export default LoadingButton;